<template>
  <el-dialog :title="'【充值】'+form.customername"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog"
             center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1">
      <el-row>
        <el-col :span="12" >
          <el-form-item label="充值金额" :label-width="formLabelWidth" prop="debit">
            <el-input-number v-model="form.debit" auto-complete="off" :required="true" :controls="false" ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="充值方式" :label-width="formLabelWidth">
            <el-select v-model="form.rechargeserial" placeholder="请选择" filterable :clearable="true" >
              <el-option
                v-for="item in buyhetongseriallist"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input v-model="form.remark" auto-complete="off"
                      :required="true"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 4}"
                      placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth">
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="tableData"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              width="50"
              label="序号"
              align="center" fixed>
              <template slot-scope="scope">
                {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="时间" width="140" fixed>
              <template slot-scope="scope">
                {{(scope.row.adddate || "").substr(0, 19)}}
              </template>
            </el-table-column>
            <el-table-column
              label="充值金额"
              align="right"
              header-align="center"
              width="130" fixed>
              <template slot-scope="scope">
                {{scope.row.debit | numeric(2)}}
              </template>
            </el-table-column>
            <!--<el-table-column-->
              <!--label="消费金额"-->
              <!--align="right"-->
              <!--header-align="center"-->
              <!--width="130" fixed-->
            <!--&gt;-->
              <!--<template slot-scope="scope">-->
                <!--{{scope.row.credit | numeric(2)}}-->
              <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
              <!--prop="paymethod"-->
              <!--label="方式"-->
              <!--align="center"-->
              <!--width="110">-->
            <!--</el-table-column>-->
            <el-table-column
              prop="rechargeserial"
              label="充值方式"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="applyby" width="100"
              align="center" header-align="center"
              label="经办人">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center" :show-overflow-tooltip="true">
            </el-table-column>

          </el-table>
            <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {saveData} from '@/api/set/recharge';
  import {getListData as bankList} from '@/api/set/PriceandKd';
  import {getListData} from '@/api/set/recharge';


  export default {
    name: "DataContactEdit",
    data() {
      return {
        dialogFormVisible: false,
        isDisable: false,
        buyhetongseriallist: [],//收款银行选择项
        form: {  //表单数据
          customername: "",
          customerserial: "",
          debit: undefined,
          remark: "",
          rechargeserial:""
        },
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        formLabelWidth: '120px'
      }
    },
    methods: {
      //收款银行
      buyhetongserial() {
        this.buyhetongseriallist=[]
        bankList({
            offset: 0,
            limit: 10000,
            paraname: '收款银行',
          }
        ).then(response => {
          var tabledata = response.data.obj

          for (let i = 0; i < tabledata.length; i++) {
            var obj = {name: '', value: ''}
            obj.name = tabledata[i].name
            obj.value = tabledata[i].unitguid
            this.buyhetongseriallist.push(obj)
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      show(customerSerial, customerName) {
        this.form.customername = customerName;
        this.form.customerserial = customerSerial;
        this.form.debit = undefined;
        this.form.remark = "";
        this.form.rechargeserial = "";
        this.dialogFormVisible = true;
        this.bindGrid();
      },
      bindGrid() {
        // if (this.beginDate == '') {
        //   let beginDate = getNowFormatDate();
        //   this.endDate = beginDate;
        //   // beginDate = getPreMonth(beginDate);
        //   this.beginDate = beginDate;
        // }
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          customerserial: this.form.customerserial,
          beginDate: '2020-01-01',
          endDate: '2099-12-31',
          paymentType: '',
          recordType: '1',
          rechargeserial: '',//充值流水号
          erpserial:'',
          servedserial:'all',
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      saveData() {
        let count =  parseInt(this.form.debit);//充值
        if (!this.form.debit||Number.isNaN(count)) {
          this.$message({
            message: "请正确输入金额",
            type: 'error'
          })
          return;
        }
        this.$refs.form1.validate((valid) => {
          if (valid) {
            saveData(this.form).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                //刷新列表
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.isDisable = false;
            });
          }
        })
      },
    },
    components: {},
    mounted() {
     this.buyhetongserial();
    },
  }
</script>





// WEBPACK FOOTER //
// src/components/set/recharge/rechargeRecord4Chuna.vue